<template>
    <div class="main">
        <div
            class="header"
            :class="{'header-shadow': windowScroll}"
        >
            <div class="header__container header__desktop">
                <a
                    :class="['logo', is_intl? 'r' : '']"
                    :href="is_intl ? 'https://rerada.com' : 'https://stocrm.ru'"
                >
                    <div class="elem" />
                </a>
                <div class="header__right">
                    <div
                        class="search"
                        :class="{'is-focus': searchFocus || search_query.length }"
                    >
                        <simple-input
                            ref="search_input"
                            v-model:model="search_query"
                            class="header__search"
                            :clear="true"
                            :search-icon="true"
                            :placeholder="getTranslate('search_wiki_articles')"
                            @focus="onFocusSearch()"
                            @blur="onBlurSearch()"
                            @onenter="search"
                            @search="search"
                        />
                        <transition name="fade">
                            <div
                                v-if="search_results && !allResultsView"
                                class="results"
                            >
                                <div
                                    v-for="(result, result_key) in search_results.slice(0, 10)"
                                    :key="result_key"
                                    class="result"
                                    @click="getArticle(result.ID, true)"
                                >
                                    <div class="name">
                                        {{ result.TITLE }}
                                    </div>
                                    <div class="sub">
                                        {{
                                            result.TEXT ? formattedDescription(result.TEXT) + '...' : getTranslate('article_not_available')
                                        }}
                                    </div>
                                </div>
                                <div
                                    v-if="search_results.length > 10"
                                    class="results__more"
                                    @click="allResultsView = true"
                                >
                                    <span>{{ getTranslate('all_results') }}</span>
                                    <div class="results__more-arrow">
                                        <img
                                            src="@/assets/images/arrow_right-blue.svg"
                                            alt="arrow"
                                        >
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="header__actions">
                        <LangDrop
                            v-if="languagesList && languagesList.length > 1"
                            :list="languagesList"
                            :active-item-prop="workflowData.languageSystem"
                            @change-item="changeSystemLang($event)"
                        />
                        <a
                            :href="!is_intl ? 'https://stocrm.ru/login' : 'https://rerada.com/login'"
                            class="header__login"
                        >
                            {{ getTranslate('login') }}
                        </a>
                    </div>
                    <a
                        :href="!is_intl ? 'https://stocrm.ru/registration/' : 'https://rerada.com/registration'"
                    >
                        <SquareButton
                            class="header__registration"
                            :text="getTranslate('registration')"
                            type="button_addit_blue"
                        />
                    </a>
                </div>
            </div>
            <div class="header__container header__mobile">
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <a
                        v-if="!mobileSearch"
                        :href="is_intl ? 'https://rerada.com' : 'https://stocrm.ru'"
                        :class="['logo', is_intl?'r':'']"
                    >
                        <div class="elem" />
                    </a>
                </transition>
                <div class="header__right">
                    <transition
                        name="width"
                        mode="out-in"
                    >
                        <div
                            v-if="mobileSearch"
                            class="header__search-mob"
                        >
                            <div
                                class="header__search-mob-arrow"
                                @click="mobileSearch = false"
                            >
                                <img
                                    src="@/assets/images/arrow_left.svg"
                                    alt="back"
                                >
                            </div>
                            <simple-input
                                ref="searching_mob"
                                v-model:model="search_query"
                                class="header__search"
                                :clear="true"
                                :search-icon="mobileSearch"
                                :placeholder="getTranslate('search_wiki_articles')"
                                @focus="onFocusSearch()"
                                @blur="onBlurSearch()"
                                @onenter="search"
                                @search="search"
                            />
                            <transition name="fade">
                                <div
                                    v-if="search_results && !allResultsView"
                                    class="results"
                                >
                                    <div
                                        v-for="(result, result_key) in search_results.slice(0, 10)"
                                        :key="result_key"
                                        class="result"
                                        @click="getArticle(result.ID, true)"
                                    >
                                        <div class="name">
                                            {{ result.TITLE }}
                                        </div>
                                        <div class="sub">
                                            {{
                                                result.TEXT ? formattedDescription(result.TEXT) + '...' : getTranslate('article_not_available')
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="search_results.length > 10"
                                        class="results__more"
                                        @click="allResultsView = true"
                                    >
                                        <span>{{ getTranslate('all_results') }}</span>
                                        <div class="results__more-arrow">
                                            <img
                                                src="@/assets/images/arrow_right-blue.svg"
                                                alt="arrow"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div
                            v-else-if="!mobileSearch"
                            class="header__right-wrapper"
                        >
                            <div
                                v-if="!mobileMenu"
                                class="header__right-search"
                                @click="openSearch"
                            >
                                <img
                                    src="@/assets/images/search_icon.svg"
                                    alt="search"
                                >
                            </div>
                            <LangDrop
                                v-if="languagesList && languagesList.length > 1 && !mobileMenu"
                                :list="languagesList"
                                :active-item-prop="workflowData.languageSystem"
                                @change-item="changeSystemLang($event)"
                                @click.stop
                            />
                            <a :href="!is_intl ? 'https://stocrm.ru/registration' : 'https://rerada.com/registration'">
                                <SquareButton
                                    class="header__registration"
                                    :text="getTranslate('registration')"
                                    type="button_addit_blue"
                                />
                            </a>
                            <BurgerButton
                                ref="burgerButton"
                                @on-click="onBurgerClick()"
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <Transition name="fade">
            <div
                v-if="mobileMenu"
                class="popup-wrapper"
            />
        </Transition>
        <Transition name="slide-top">
            <MobileMenu
                v-if="mobileMenu"
                :current-article="current_article"
                :catalog="menu"
                :level="1"
                :article-action="getArticle"
            />
        </Transition>
        <div
            class="content"
            :class="{'content--hidden': mobileMenu}"
        >
            <div
                v-if="!allResultsView"
                class="sidebar"
            >
                <div class="menu">
                    <a
                        href="/wiki"
                        class="project-name"
                    >{{ !is_intl ? 'STOCRM' : 'RERADA' }} WiKi</a>
                    <template v-if="Object.keys(menu).length">
                        <catalog
                            class="content__catalog"
                            :current-article="current_article"
                            :catalog="menu"
                            :level="1"
                            :article-action="getArticle"
                        />
                    </template>
                </div>
            </div>
            <div
                ref="content_container"
                class="contents"
                @scroll="handlerDesktopScroll"
            >
                <template v-if="!allResultsView">
                    <StartView
                        v-if="!article && workflowData.languageSystem"
                        ref="start_view"
                    />
                    <div
                        v-else
                        class="article"
                    >
                        <div
                            v-if="breadcrumbs.length"
                            class="breadcrumbs main__breadcrumbs"
                        >
                            <div
                                v-for="(item, index) in breadcrumbs"
                                :key="index"
                                class="breadcrumbs__item"
                                :class="{'is-active': item.ID === current_article}"
                                @click="getArticle(item.ID)"
                            >
                                <span>{{ item.TITLE }}</span>
                            </div>
                        </div>
                        <div class="heading">
                            <div class="name">
                                {{ article.TITLE }}
                                <span>{{
                                    article.DATE_UPDATE ? `${getTranslate('last_updated')} ` + moment(article.DATE_UPDATE_UNIX_TIMESTAMP * 1000).format('D MMMM YYYY') : `${getTranslate('created')} ` + moment(article.DATE_CREATE_UNIX_TIMESTAMP * 1000).format('D MMMM YYYY')
                                }}</span>
                            </div>
                            <div
                                class="copy"
                                @click="copyUrl"
                            >
                                <img
                                    src="@/assets/images/copy.svg"
                                    alt="copy"
                                >
                            </div>
                        </div>
                        <template v-if="article">
                            <template v-if="!article.TEXT">
                                {{ getTranslate('article_not_available') }}
                            </template>
                            <Markdown
                                ref="markdownitvue"
                                class="markdown-body"
                                :source="article.TEXT || ''"
                                :html="true"
                                :linkify="false"
                            />
                            <template v-if="sub_articles">
                                <div class="subheader">
                                    {{ getTranslate('sub_articles') }}
                                </div>
                                <template
                                    v-for="(subar, subind) in sub_articles"
                                    :key="subind+'_alt'"
                                >
                                    <a
                                        class="subarticle"
                                        :href="!is_intl ? '/wiki/article/' + subar.ID : '/wiki/' + workflowData.languageSystem.toLowerCase() + '/article/' + subar.ID"
                                    >
                                        {{ subar.TITLE }}
                                    </a>
                                    <br>
                                </template>
                            </template>
                        </template>
                    </div>
                </template>
                <template v-if="allResultsView">
                    <div class="results__wrapper">
                        <div
                            v-if="paginatedData.length"
                            class="results"
                        >
                            <transition-group name="fade-list">
                                <div
                                    v-for="(result) in paginatedData"
                                    :key="result.TEXT"
                                    class="result"
                                    @click="getArticle(result.ID, true), allResultsView = false, mobileSearch = false"
                                >
                                    <div class="name">
                                        {{ result.TITLE }}
                                    </div>
                                    <div class="sub">
                                        {{
                                            result.TEXT ? formattedDescription(result.TEXT) + '...' : getTranslate('article_not_available')
                                        }}
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                        <div
                            v-else
                            class="results"
                        >
                            <span>{{ getTranslate('nothing_found') }}</span>
                        </div>
                        <PaginationBar
                            class="results__pagination"
                            :list="search_results"
                            @change-page="onChangePage($event)"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
    <textarea
        id="tempInput"
        readonly="readonly"
        type="text"
    />
    <div
        v-if="workflowData && workflowData.meta.flyout_o"
        :class="['flyout','animated']"
        :style="'top:'+workflowData.meta.flyout_o.y+'px; left:'+workflowData.meta.flyout_o.x+'px;'"
    >
        {{ workflowData.meta.flyout_o.text }}
    </div>
</template>
<script>
import BurgerButton from "@/components/BurgerButton.vue";
import catalog from './components/catalog.vue';
import MobileMenu from "@/partials/MobileMenu.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import SimpleInput from './components/SimpleInput';
import StartView from "@/partials/StartVIew.vue";
import SquareButton from "@/components/SquareButton.vue";

import Markdown from 'vue3-markdown-it';
import 'markdown-it-vue/dist/markdown-it-vue-light.css'

import * as moment from 'moment';
import 'moment/locale/ru';
import LangDrop from "@/partials/LangDrop.vue";

moment.locale('ru');

export default {
    name: 'Wiki',
    components: {
        LangDrop,
        MobileMenu,
        StartView,
        SquareButton,
        SimpleInput,
        catalog,
        Markdown,
        BurgerButton,
        PaginationBar
    },
    data() {
        return {
            raw: false,
            menu: {},
            search_query: '',
            searched_query: '',
            search_results: false,
            article: false,
            current_article: false,
            breadcrumbs: [],

            searchFocus: false,
            mobileMenu: false,
            mobileSearch: false,
            windowScroll: false,
            allResultsView: false,

            paginatedData: false,

            languagesList: false,
        }
    },
    computed: {
        brand_domain() {
            let domain = document.location.hostname;
            if (this.isNumeric(document.location.hostname.split('.').join(''))) {
                domain = this.is_intl ? atob('cmVyYWRhLmNvbQ==') : atob('c3RvY3JtLnJ1')
            } else {
                const domain_arr = document.location.hostname.split('.')
                const domain_cnt = domain_arr.length - 2;
                if (domain_cnt) {
                    domain_arr.splice(0, domain_cnt);
                    domain = domain_arr.join('.');
                }
            }
            return domain;
        },
        sub_articles() {
            let subs = false;
            if (this.current_article && this.raw[this.current_article]?.HAS_CHILDES) {
                let path = this.findPath(this.current_article, [], this.raw);
                path = path.reverse();
                let coll = false;
                path.forEach((art) => {
                    if(path.length === 1) {
                        subs = this.menu[this.current_article].SUB_ARTICLES
                    } else {
                        if (!coll) {
                            coll = Object.values(this.menu).find(item => item.ID === art)
                        } else {
                            coll = coll.SUB_ARTICLES.find(item => item.ID === art);
                        }
                    }
                    if (coll && coll.SUB_ARTICLES && coll.SUB_ARTICLES.find(item => item.ID === this.current_article)) {
                        subs = coll.SUB_ARTICLES.find(item => item.ID === this.current_article).SUB_ARTICLES || false
                    }
                });
            }
            return subs;
        },
        // hostname() {
        //     return document.location.hostname;
        // },
    },
    async created() {
        await this.loadListLanguages()

        const unwatch = this.$watch('article', (newVal, oldVal) => {
            this.setDocumentTitle(this.article.TITLE)
            this.setMetaDescription(this.article.TEXT)
        }, {
            deep: true
        })
    },
    mounted() {
        if (!this.is_intl) this.loadScripts();
        window.addEventListener('scroll', this.handlerMobScroll)
    },
    unmounted() {
        window.removeEventListener('scroll', this.handlerMobScroll)
    },
    methods: {
        setDocumentTitle(title) {
            if(!title) return

            document.title = title ?? ''
        },
        setMetaDescription(descriptionText) {
            if(!descriptionText) return

            const descr = (typeof descriptionText === 'string' && descriptionText.length > 30) ? descriptionText.slice(0, 30) : descriptionText
            const metaDescription = document.querySelector('meta[name="description"]')
            if(metaDescription) metaDescription.setAttribute('content', descr)
            else {
                const meta = document.createElement('meta')
                meta.name = 'description'
                meta.content = descr
                document.head.appendChild(meta)
            }
        },
        changeSystemLang(lang) {
            this.workflowData.languageSystem = lang;
            history.replaceState(false, '', '/wiki/' + this.workflowData.languageSystem.toLowerCase());
            this.current_article = false
            this.article = false;
            this.loadMenu();
        },
        formattedDescription(text) {
            if (!text) return
            const loweredText = text.toLowerCase()
            if (!loweredText.indexOf(this.searched_query.toLowerCase()) || loweredText.indexOf(this.searched_query.toLowerCase()) === -1) {
                return loweredText.slice(0, 40)
            } else return loweredText.slice(loweredText.indexOf(this.searched_query.toLowerCase()), loweredText.indexOf(this.searched_query.toLowerCase()) + 40)
        },
        onChangePage(data) {
            this.paginatedData = data
            if (window) window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        findSubBreadcrumb(object, field, value) {
            for (let key in object) {
                if (object[key][field] === value) {
                    return object[key];
                }
                if (object[key].SUB_ARTICLES) {
                    let result = this.findSubBreadcrumb(object[key].SUB_ARTICLES, field, value);
                    if (result) {
                        return result;
                    }
                }
            }
        },
        formBreadcrumbs(item) {
            if (item.LEVEL === '1') {
                this.breadcrumbs = []
                this.breadcrumbs.push(item)
                return
            }

            if (item.PARENT_ID && item.PARENT_ID !== '0') {
                const parent = this.findSubBreadcrumb(this.menu, 'ID', item.PARENT_ID)
                if (parent) {
                    const parentIndex = this.breadcrumbs.findIndex(item => item.ID === parent.ID)
                    this.breadcrumbs = this.breadcrumbs.slice(parentIndex + 1)
                    this.formBreadcrumbs(parent)
                }
            }
            this.breadcrumbs.push(item)
        },
        handlerDesktopScroll() {
            const content = this.$refs.content_container
            this.windowScroll = content.scrollHeight - content.scrollTop < content.scrollHeight;
        },
        handlerMobScroll() {
            this.windowScroll = window && window.scrollY > 0;
        },
        onBurgerClick() {
            this.mobileMenu = !this.mobileMenu
            this.windowScroll = false
        },
         async openSearch() {
            this.mobileSearch = true
            if (this.mobileMenu && this.$refs.burgerButton) {
                this.$refs.burgerButton.onBurgerClick()
            }
            setTimeout(() => {
                if (this.$refs.searching_mob) this.$refs.searching_mob.focusTextField()
            }, 400)
        },
        onFocusSearch() {
            this.searchFocus = true
        },
        onBlurSearch() {
            this.searchFocus = false
        },
        async resolve(url, data, exc) {
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'same-origin',
                });
                const response_data = await response.json();
                if (typeof data === 'function') {
                    return data(response_data);
                } else if (exc) {
                    return exc(response_data);
                }
                return response_data;
            } catch (error) {
                console.log(error.message);
                throw error;
            }
        },
        async loadListLanguages() {
            await this.resolve('/ajax/wiki/langs/', (output) => {
                if(output.CODE === 200) {
                    this.languagesList = output.RESPONSE
                    this.parseLanguageUrl()
                    this.loadMenu()
                }
            })
        },
        loadMenu() {
            this.resolve('/ajax/wiki/menu/?LANG=' + this.workflowData.languageSystem, (output) => {
                if (output.CODE === 200) {
                    const { ALL, ...rest } = output.RESPONSE
                    this.menu = { ...rest }
                    this.raw = ALL
                    this.parseArticleUrl();
                }
            });
        },

        getArticle(id, parse, item) {
            if (this.current_article !== id) {
                this.resolve('/ajax/wiki/article/', {
                    ARTICLE: id,
                }, (output) => {
                    if (output.CODE === 200) {
                        const article = JSON.parse(JSON.stringify(output.RESPONSE[id]));
                        if (article.TEXT) {
                            if (article.ATTACHES) {
                                const attachesObject = JSON.parse(article.ATTACHES)
                                Object.keys(attachesObject).forEach(attach_id => {
                                    const attach = attachesObject[attach_id];
                                    if (attach_id.includes('mp4')) {
                                        article.TEXT = article.TEXT.replace('![](' + attach.name + ')', '<span><video style="max-width: 100%;" src="//youtrack.' + this.brand_domain + attach.url + '?&' + attach_id + '" controls></video></span>');
                                    } else if (attach_id.includes('png') || attach_id.includes('jpg') || attach_id.includes('gif') || attach_id.includes('jpeg') || attach_id.includes('PNG') || attach_id.includes('webp')) {
                                        // article.TEXT = article.TEXT.replace(attach.name, 'https://youtrack.stocrm.ru' + attach.url + '?&' + attach_id);
                                        article.TEXT = article.TEXT.replace('![](' + attach.name + ')', '<img class="helper_image" alt="helper_img" style="max-width: 100%;" src="//youtrack.' + this.brand_domain + attach.url + '?&' + attach_id + '"/>');
                                    } else {
                                        article.TEXT = article.TEXT.replace(attach.name, 'https://youtrack.' + this.brand_domain + attach.url + '?&' + attach_id);
                                    }
                                });
                            }
                            article.TEXT = article.TEXT.replaceAll(/!\[([^\]]*)\]\(https:\/\/www\.youtube\.com\/watch\?v=([\w-]+).*?\)/g, (match, title, videoId) => {
                                const videoUrl = `https://www.youtube.com/embed/${videoId}`;
                                return `<span>${title}</span><iframe width="560" height="315" src="${videoUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
                            })
                            article.TEXT = article.TEXT.replaceAll('youtrack.' + this.brand_domain + '/articles', this.brand_domain + '/wiki/article');
                            article.TEXT = article.TEXT.replaceAll(/(WIKI-A-(.*\d))/g, match => {
                                return '[' + (this.raw[match] ? this.raw[match].TITLE : match) + '](https://' + this.brand_domain + '/wiki/article/' + match + ')';
                            });
                        }

                        this.article = article
                        this.current_article = id
                        this.formBreadcrumbs(this.article)
                        this.allResultsView = false
                        if (this.$refs.content_container) {
                            setTimeout(() => {
                                this.$refs.content_container.scrollTop = 0;
                            }, 50);
                        }

                        this.setArticleUrl(id);
                        if (parse) {
                            this.parseArticleUrl();
                        }
                        if (item && !item.SUB_ARTICLES) {
                            if (this.mobileMenu) {
                                this.$refs.burgerButton.onBurgerClick()
                            }
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            })
                        }
                    }
                });
            }
            this.search_results = false
            this.search_query = ''
            this.searched_query = ''
        },

        moment(date) {
            return moment(date);
        },

        setArticleUrl(id) {
            let path = document.location.pathname.split('/');
            let articleIndex = path.indexOf('article');
            if(articleIndex > 0) {
                path[path.indexOf('article') + 1] = id
            } else {
                if (path[2] === '') {
                    path.splice(2, 1);
                }
                path.push('article');
                articleIndex = path.indexOf('article');
                path[articleIndex + 1] = id
            }
            path = path.join('/');
            history.replaceState(false, 'Article ' + id, path);
        },

        parseArticleUrl() {
            const path = document.location.pathname.split('/');
            const articleIndex = path.indexOf('article');
            if(articleIndex > 0) {
                const articleId = path[articleIndex + 1]
                if(this.raw[articleId]) {
                    this.getArticle(articleId)
                    this.showMenuArticle(articleId)
                }
            }
        },
        setDefaultLanguage() {
            const setLang = (defaultLang) => {
                if(this.languagesList.includes(defaultLang)) {
                    this.workflowData.languageSystem = defaultLang
                } else this.languagesList = this.languagesList[0]
            }

            if(this.is_intl) {
                const defaultLang = 'EN'
                setLang(defaultLang)
            } else {
                const defaultLang = 'RU'
                setLang(defaultLang)
            }
        },
        parseLanguageUrl() {
            const path = window.location.pathname.toLowerCase().split('/');
            this.languagesList.forEach(item => {
                if(path.includes(item.toLowerCase())) {
                    this.workflowData.languageSystem = item
                }
            })
            if(!this.workflowData.languageSystem) this.setDefaultLanguage()
        },

        showMenuArticle(id) {
            let path = this.findPath(id, [], this.raw);
            if (path.length === 1) {
                path.splice(-1, 1);
            }
            path.push(id)
            path = path.reverse();
            this.expandFolders(false, path)
        },

        expandFolders(folder, path) {
            folder = folder || this.menu;
            path.forEach(node => {
                const currentFolder = folder[node] || Array.isArray(folder) && folder.find(item => item.ID === node)
                if (currentFolder) {
                    path.splice(path.indexOf(node), 1);
                    currentFolder.expanded = true
                    if (currentFolder.SUB_ARTICLES) {
                        this.expandFolders(currentFolder.SUB_ARTICLES, path);
                    }
                }
            });
        },

        findPath(id, path, col) {
            path = path || [];
            if (id && col && col[id] && col[id].PARENT_ID) {
                path.push(col[id].PARENT_ID);
                this.findPath(col[id].PARENT_ID, path, col)
            }
            return path;
        },

        copyUrl() {
            this.copy(document.location.href);
        },

        search() {
            if (this.search_query === this.searched_query) return false
            if (!this.search_query || this.search_query.trim().length < 2) {
                this.search_results = false
                return false;
            }
            this.resolve('/ajax/wiki/search/?QUERY=' + this.search_query + '/', {
                LANG: this.workflowData.languageSystem
            }, output => {
                if (output.CODE === 200) {
                    this.search_results = output.RESPONSE
                    this.searched_query = this.search_query
                } else {
                    this.search_results = false
                }
            });
        },
        loadScripts() {
            const chat_script = document.createElement('script');
            chat_script.setAttribute('src', '//code.jivo.ru/widget/VmrRQNXEvJ');
            chat_script.async = true;
            document.head.appendChild(chat_script);
        }
    }
}
</script>

<style>
@import './assets/base.css';

.main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
}

.header {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 40;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--white);
    padding: 0 40px;
    transition: .3s ease-in-out all;
}

.header.header-shadow {
    box-shadow: 0 4px 10px 0 #00000026;
}

.header .header__container {
    display: flex;
    align-items: center;
    width: 100%;
}

.header .header__mobile {
    display: none;
}

.header .logo {
    height: 32px;
    width: 215px;
    margin-right: 118px;
}

.breadcrumbs {
    display: flex;
    align-items: center;
    column-gap: 12px;
}

.breadcrumbs.main__breadcrumbs {
    margin-bottom: 40px;
}

.breadcrumbs .breadcrumbs__item {
    cursor: pointer;
    max-width: 200px;
    display: flex;
    align-items: center;
}

.breadcrumbs .breadcrumbs__item span {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.breadcrumbs .breadcrumbs__item::after {
    content: '/';
    margin-left: 15px;
    width: 7px;
    height: 13px;
    font-size: 12px;
    line-height: 13px;
    color: var(--muted-background);
}

.breadcrumbs .breadcrumbs__item span {
    font-size: 12px;
    line-height: 13px;
    color: var(--muted-background);
}

.breadcrumbs .breadcrumbs__item.is-active {
    cursor: default;
}

.breadcrumbs .breadcrumbs__item.is-active::after {
    display: none;
}

.breadcrumbs .breadcrumbs__item.is-active span {
    color: var(--additional-dark-blue);
}

.main .sidebar {
    position: fixed;
    width: 373px;
    left: 0;
    border-right: 1px solid var(--primary-muted);
    height: calc(100% - 80px);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
}

.logo .elem {
    content: '';
    background-image: url('./assets/images/logo.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    display: block;
}

.logo.r .elem {
    background-image: url('./assets/images/rlogo.svg');
}

.main .project-name {
    font-size: 20px;
    padding-left: 10px;
    line-height: 24px;
    font-weight: 400;
    color: var(--black);
}

.main .content__catalog {
    margin-top: 20px;
}

.main .sidebar .menu {
    height: 100%;
    width: 100%;
    overflow: auto;
    padding: 20px 6px 20px 30px;
}

.main .sidebar .menu::-webkit-scrollbar {
    position: absolute;
    width: 5px;
}

.main .sidebar .menu::-webkit-scrollbar-thumb {
    background-color: #ABABAB;
}

.main .content {
    width: 100%;
    height: calc(100% - 80px);
    margin-top: auto;
    padding-bottom: 20px;
    transition: .3s ease-in-out background;
}
.main .content.content--hidden {
    pointer-events: none;
}

.main .content .header > span {
    color: #FFFFFF;
    font-size: 24px;
}

.header .header__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: calc(100% - 373px);
}

.header__mobile .header__right {
    column-gap: 12px;
}
.header__mobile .header__right {
    width: 100%;
}

.header .header__right .header__actions {
    display: flex;
    align-items: center;
    column-gap: 20px;
    margin-left: 20px;
}

.header .header__right .header__registration {

    margin-left: 20px;
}

.header .header__right .header__actions .header__login {
    color: var(--primary-blue);
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
}

.header .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 306px;
    position: relative;
    transition: 1s ease-in-out width;
}

.header__search-mob {
    width: 100%;
    position: relative;
}

.header__right .header__search-mob {
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.header__right .header__search-mob-arrow {
    width: 16px;
    height: 16px;
    font-size: 0;
    cursor: pointer;
    user-select: none;
}

.header__right .header__search-mob-arrow img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.header__right-search {
    width: 22px;
    height: 22px;
    font-size: 0;
    cursor: pointer;
}

.header__right-search img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.header .search.is-focus {
    width: 100%;
}

.header .search .results,
.header .header__search-mob .results {
    position: absolute;
    top: 50px;
    right: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 10;
    width: 100%;
    max-height: calc(90vh - 80px);
    overflow: hidden;
    overflow-y: auto;
}

.results {
    background: #fff;
}

.results .results__more {
    cursor: pointer;
    padding: 16px 28px;
    display: flex;
    align-items: center;
    column-gap: 8px;
    border-top: 1px solid var(--muted-background);
}

.results .results__more:hover .results__more-arrow {
    transform: translateX(5px);
}

.results .results__more span {
    font-size: 14px;
    line-height: 24px;
    color: rgba(48, 119, 189, 0.8);
}

.results .results__more-arrow {
    width: 6px;
    height: 12px;
    font-size: 0;
    transition: .3s ease-in-out transform;
}

.results .results__more-arrow img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.results::-webkit-scrollbar {
    position: absolute;
    width: 3px;
}

.results::-webkit-scrollbar-thumb {
    background-color: #ABABAB;
}

.results .result {
    padding: 12px 20px;
    transition: .3s ease-in-out;
    cursor: pointer;
}

.results .result:hover {
    background: #f7f7f7;
}

.results .result:last-child {
    border-bottom: 0;
}

.results .result .name {
    position: relative;
    display: inline-block;
}

.results .result .name::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 0;
    width: 0;
    height: 1px;
    background: rgba(48, 119, 189, 0.8);
    transition: .5s ease-in-out width;
}

.results .result .name {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 4px;
    color: rgba(48, 119, 189, 0.8);
}

.results .result:hover .name::after {
    width: 100%;
}

.results .result .sub {
    color: #999;
    font-size: 12px;
    line-height: 13px;
}

.main .content .contents {
    right: 0;
    margin-left: auto;
    height: 100%;
    width: calc(100% - 373px);
    overflow: hidden;
    overflow-y: auto;
}
.main .content .contents::-webkit-scrollbar {
    height: 10px;
    width: 8px;
}
.main .content .contents::-webkit-scrollbar-thumb {
    background-color: var(--primary-blue);
    border-radius: 4px;
}
.main .content .contents .article {
    max-width: 1290px;
    width: auto;
    padding: 0 20px;
    margin: 0 auto;
}

.main .content .contents .article .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    color: #000000;
    font-size: 30px;
    font-weight: 900;
    border-bottom: 1px solid #eee;
    padding-bottom: 11px;
}

.main .content .contents .article .heading .name span {
    display: block;
    color: #999;
    font-size: 15px;
    font-weight: initial;
    margin-top: 12px;
}

.main .content .contents .article .heading .copy {
    padding: 2px;
    width: 16px;
    height: 16px;
    font-size: 0;
    transition: .3s ease background;
    border-radius: 4px;
    cursor: pointer;
    flex-shrink: 0;
}

.main .content .contents .article .heading .copy:hover {
    background: #F5F5F5;
}

.main .content .contents .article .heading .copy img {
    width: 100%;
    height: 100%;
}

.markdown-body img {
    box-shadow: 0 0 11px 0 #e0e0e0 !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.main .content .contents .article .subheader {
    margin-top: 30px;
    font-size: 20px;
    margin-bottom: 11px;
}

.main .content .contents .article a.subarticle {
    text-decoration: none;
    margin-bottom: 7px;
    font-size: 17px;
    display: inline-block;
    color: rgba(48, 119, 189, 0.8);
}

.results__wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    height: calc(100% - 80px);
    padding-bottom: 80px;
}

.results__wrapper .results {
    flex: 1;
}
.popup-wrapper {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 20;
}
.flyout {
    position: fixed;
    z-index: 100;
    pointer-events: none;
    animation: floatup .5s ease-in-out;
    opacity: .001;
    text-align: center;
    transform: translate3d(-50%,0,0);
    -webkit-backface-visibility: hidden;
    white-space: nowrap;
    color: rgba(48, 119, 189, 0.8);
}

.header__right-wrapper {
    display: flex;
    column-gap: 12px;
    align-items: center
}

@keyframes floatup {
    20% {
        opacity: .999
    }

    100% {
        transform: translate3d(-50%,-17px,0)
    }
}

@media only screen and (max-width: 1024px) {
    .header {
        width: 100%;
        padding: 0 20px;
    }

    .header .header__desktop {
        display: none;
    }

    .header .header__mobile {
        display: flex;
    }

    .header .logo {
        height: 24px;
        width: 150px;
        flex-shrink: 0;
    }

    .main {
        position: static;
    }

    .main .sidebar {
        position: static;
        margin-top: 80px;
        width: calc(100% - 48px);
        margin-left: auto;
        margin-right: auto;
        border: none;
        border-top: 1px solid var(--muted-background);
        padding-top: 20px;
    }

    .main .sidebar .menu {
        padding: unset;
    }

    .main .content {
        display: flex;
        flex-direction: column-reverse;
        overflow: hidden;
        margin-bottom: 80px;
        padding-top: 80px;
    }

    .main .content .contents {
        width: 100%;
    }

    .results__wrapper {
        width: 100%;
        height: auto;
    }

    .results__pagination {
        justify-content: center;
        margin-top: 62px;
    }

    .breadcrumbs .breadcrumbs__item {
        user-select: none;
    }
}

@media only screen and (max-width: 768px) {
    .header .header__right .header__registration {
        display: none;
    }
    .header .header__right {
        width: 100%;
    }
    .header .logo {
        margin-right: unset;
    }
}
.label_aefc {
    opacity: 0 !important;
}
.width-enter-active,
.width-leave-active {
    transition: .3s ease-in-out all;
}

.width-enter-from,
.width-leave-to {
    width: 0;
}

.width-leave-to {
    position: absolute;
    opacity: 0;
}
</style>
